import { CheckCircle2, XCircle, HelpCircle } from "lucide-react";

const STATUS = {
  GO: { c: "#22C55E", Icon: CheckCircle2 },
  "NO-GO": { c: "#EF4444", Icon: XCircle },
  UNKNOWN: { c: "#F59E0B", Icon: HelpCircle },
};

const fmt = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleTimeString("fr-FR", { hour12: false });
};

export const ReadinessRow = ({ row }) => {
  const s = STATUS[row.status] || STATUS.UNKNOWN;
  return (
    <div className="grid grid-cols-[16px_1fr_auto] gap-2 items-start py-1.5 border-b border-white/5 last:border-0"
      data-testid={`ota-ready-row-${row.key}`}>
      <s.Icon size={13} style={{ color: s.c }} className="mt-0.5" />
      <div className="min-w-0">
        <div className="text-[11px] text-[#E5E5E5]">{row.label}
          <span className="text-[9px] text-[#737373] ml-2 uppercase tracking-wider">{row.source}</span></div>
        <div className="text-[10px] text-[#A3A3A3] break-words" data-testid={`ota-ready-reason-${row.key}`}>{row.reason || "—"}</div>
      </div>
      <div className="text-right">
        <div className="font-mono text-[10px] font-bold" style={{ color: s.c }} data-testid={`ota-ready-status-${row.key}`}>{row.status}</div>
        <div className="font-mono text-[9px] text-[#525252]">{fmt(row.evidence_at)}</div>
      </div>
    </div>
  );
};

export const ReadinessChecklist = ({ readiness, expired }) => {
  if (!readiness) return <div className="text-[11px] text-[#737373]" data-testid="ota-readiness-loading">Vérification du préflight…</div>;
  if (readiness.error) return <div className="text-[11px] text-[#EF4444]" data-testid="ota-readiness-error">Préflight indisponible — aucune action autorisée</div>;
  return (
    <div data-testid="ota-readiness">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[9px] uppercase text-[#737373] tracking-wider">Checklist — cible {readiness.target_release || "—"}</span>
        <span className={`font-mono text-[9px] ${expired ? "text-[#F59E0B]" : "text-[#525252]"}`} data-testid="ota-readiness-expiry">
          {expired ? "Preuves expirées — revérifier" : `Preuves du ${fmt(readiness.checked_at)} · valides ${readiness.ttl_s}s`}
        </span>
      </div>
      {(readiness.rows || []).map((r) => <ReadinessRow key={r.key} row={r} />)}
    </div>
  );
};
